import type { Ctx } from "../../types";
import { FormAction, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";
import { invokeApi, parse } from "../_helpers";
import { school_schema } from "./_schema";

export const create_school: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(school_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, "api/schools", {
    method: "POST",
    body: parsed.data,
  });
  if (!result.ok) return result;
  invalidate("schools");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: "School created!" });
  return result;
};
